import { animated } from "react-spring";
import store from "../../../../appStore";
import { useSnapshot } from "valtio";
import { useTranslation } from "react-i18next";
import HardeningImage from "/assets/images/ApplicationsIcons/hardening.svg";
import BrazingImage from "/assets/images/ApplicationsIcons/brazing.svg";
import WeldingImage from "/assets/images/ApplicationsIcons/welding.svg";
import BondingImage from "/assets/images/ApplicationsIcons/bonding.svg";
import ShrinkImage from "/assets/images/ApplicationsIcons/shrink.svg";
import IndustryApplication from "./IndustryApplication";
import { useMemo } from "react";
import { useSpring } from "react-spring";

const applicationsHeating = [
  {
    name: "hardening",
    textId: "L3_INDUSTRIES_HARDENING",
    image: HardeningImage,
    color: "#FF7E88",
    href: "heat/applications/hardeningTempering",
    industries: ["Automotive", "RenewableEnergy", "HVAC", "infrastructure"],
  },
  {
    name: "brazing",
    textId: "L3_INDUSTRIES_BRAZING",
    image: BrazingImage,
    color: "#FFC37E",
    href: "heat/applications/brazing",
    industries: ["Automotive", "RenewableEnergy", "HVAC", "infrastructure"],
  },
  {
    name: "welding",
    textId: "L3_INDUSTRIES_WELDING",
    image: WeldingImage,
    color: "#61DFFF ",
    href: "heat/applications/welding",
    industries: ["HVAC", "infrastructure"],
  },
  {
    name: "bonding",
    textId: "L3_INDUSTRIES_BONDING",
    image: BondingImage,
    color: "#97E58B",
    href: "heat/applications/bonding",
    industries: ["Automotive", "HVAC", "infrastructure"],
  },
  {
    name: "shrink",
    textId: "L3_INDUSTRIES_SHRINK",
    image: ShrinkImage,
    color: "#FFF671",
    href: "#",
    industries: [],
  },
];

const HeatingIndustriesApplicationsUI = ({ industryId = "Automotive", visible = false }) => {
  const snap = useSnapshot(store);
  const { t } = useTranslation();

  const applications = useMemo(() => {
    return applicationsHeating.filter((a) => a.industries.includes(industryId));
  }, [industryId]);

  const { opacity } = useSpring({
    opacity: visible ? 1 : 0,
    config: { duration: 200 },
    delay: visible ? 500 : 0,
  });

  return (
    <animated.div
      style={{
        position: "absolute",
        left: "0",
        width: snap.sideBarVisible && !snap.sideBarToggle ? "73vw" : "100vw",
        transition: "0.5s",
        zIndex: "1",
        // height: "15vh",
        bottom: "5vh",
        display: "flex",
        justifyContent: "center",
        alignContent: "center",
        alignItems: "center",
        pointerEvents: "none",
        opacity: opacity,
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          color: "#fff",
          fontSize: "0.75vw",
          marginRight: "1vw",
        }}
      >
        {/* {t("L3_APPLICATIONS_IP_FEATURES")} */}
        {t("L3_INDUSTRIES_DESCRIPTION_APPLICATIONS")}
      </div>

      {applications.map((application, i) => {
        return <IndustryApplication key={i} application={application} />;
      })}
    </animated.div>
  );
};

export default HeatingIndustriesApplicationsUI;
